module.exports = __webpack_public_path__ + "media/assets/icons/dashboard-173ecfea52b5beb4089a7ed7d93811a5.svg";